export const TAGS = {
  orders: 'orders',
  users: 'users',
  proxies: 'proxies',
  accounts: 'accounts',
  steamOrders: 'steam-orders',
  redeems: 'redeems',
  cdkeys: 'cdkeys',
  fx: 'fx',
  notifications: 'notifications',
  operations: 'operations',
  audit: 'audit',
} as const;
export type Tag = (typeof TAGS)[keyof typeof TAGS];
function stableStringify(value: unknown): string {
  return JSON.stringify(value, (_key, val: unknown) => {
    if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
      const record = val as Record<string, unknown>;
      return Object.keys(record)
        .sort()
        .reduce<Record<string, unknown>>((acc, key) => {
          acc[key] = record[key];
          return acc;
        }, {});
    }
    return val;
  });
}
export const qk = {
  steamOrdersList: (params: unknown) => `steam-orders:list:${stableStringify(params)}`,
  steamOrdersStats: (params: unknown) => `steam-orders:stats:${stableStringify(params)}`,
  /** 订单账号单行：兑换工作台的金额维度是「这一对」，不是整单。 */
  steamOrderMount: (orderNo: string, username: string) =>
    `steam-orders:mount:${orderNo}/${username}`,
  steamOrderRedeemHistory: (username: string, orderNo: string) =>
    `steam-order-redeem:history:${orderNo}/${username}`,
  orderAccountBind: (orderNo: string, username: string) => `order-account:${orderNo}/${username}`,
  orderAccountRedeemHistory: (orderNo: string, username: string) =>
    `redeem:history:${orderNo}/${username}`,
  redeemStats: (params: unknown) => `redeem:stats:${stableStringify(params)}`,
  redeemExportOptions: () => 'redeem:export-options',
  redeemList: (params: unknown) => `redeems:list:${stableStringify(params)}`,
  proxyList: (params: unknown) => `proxies:list:${stableStringify(params)}`,
  proxyStats: (params: unknown) => `proxies:stats:${stableStringify(params)}`,
  cdkeyList: (params: unknown) => `cdkeys:list:${stableStringify(params)}`,
  cdkeyStats: (params: unknown) => `cdkeys:stats:${stableStringify(params)}`,
  cdkeyBindStatus: (token: string) => `cdkeys:bind-status:${token}`,
  /** 汇率快照无筛选 ⇒ key 是常量；新鲜度由 staleTime 控制。 */
  fxRates: () => 'fx:rates',
  userList: (params: unknown) => `users:list:${stableStringify(params)}`,
  userStats: (params: unknown) => `users:stats:${stableStringify(params)}`,
  grantCandidates: (keyword: string) => `grant:candidates:${keyword}`,
  grantsOfPair: (orderNo: string, username: string) => `steam-orders:grants:${orderNo}/${username}`,
  /** 未读数**不带筛选** —— 它就是全局未读，所以 key 是常量。 */
  notificationsUnread: () => 'notifications:unread-count',
  /**
   * 通知行列表——按**页**取。
   *
   * ⚠️ 后端给的是 `page` / `total`（一页一页翻），不是「取前 N 条」⇒ key
   * 里带页码，不同页是不同的缓存。筛选只有「仅未读」一档 ⇒ 后端过滤
   * （`unread_only`），前端不筛。
   */
  notificationsList: (params: { page: number; size: number; unreadOnly: boolean }) =>
    'notifications:list:' + stableStringify(params),
  profile: () => 'profile:me',
} as const;
